import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { Flex, Icon, UiText } from '@shared/ui';

import cls from './EmptyReport.module.css';

interface EmptyReportProps {
    classes?: string;
}

export const EmptyReport = ({ classes }: EmptyReportProps) => {
    const { t } = useTranslation();

    return (
        <Flex
            direction="column"
            align="center"
            justify="center"
            gap={8}
            className={cn(cls.EmptyReport, [classes])}
        >
            <Icon iconName="emptyReport" />
            <UiText classes={cls.title} weight="bold" tag="h1" variant="heading">
                {t('EmptyReport.return.UiText.title')}
            </UiText>

            <UiText classes={cls.subTitle} variant="plain">
                {t('EmptyReport.return.UiText.subTitle')}
            </UiText>
        </Flex>
    );
};
